import React, { useEffect, useMemo, useState } from "react";
import Chart from "react-apexcharts";
import { Card } from "react-bootstrap";
import analyticsService from "../../redux/services/analytics.service";

const TopSellingProducts = ({ from, to, storeId }) => {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      try {
        const res = await analyticsService.topProducts({ from, to, storeId, limit: 10 });
        const d = res.data?.data ?? res.data;
        if (!alive) return;
        setRows(Array.isArray(d?.rows) ? d.rows : Array.isArray(d) ? d : []);
      } catch {
        if (!alive) return;
        setRows([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [from, to, storeId]);

  const categories = useMemo(
    () => rows.map((r) => r.product?.name ?? r.name ?? r.productName ?? r.productPublicId ?? "—"),
    [rows]
  );

  const options = useMemo(
    () => ({
      chart: { type: "bar" },
      xaxis: { categories },
      title: { text: "Top selling products", align: "left" },
      dataLabels: { enabled: false },
    }),
    [categories]
  );

  const series = useMemo(() => {
    const qty = rows.map((r) => Number(r.qtySold ?? r.qty ?? 0) || 0);
    const sales = rows.map((r) => Number(r.netSales ?? r.sales ?? 0) || 0);
    return [
      { name: "Qty sold", data: qty },
      { name: "Net sales", data: sales },
    ];
  }, [rows]);

  return (
    <Card className="mb-4 shadow-sm">
      <Card.Body>
        <div className="small text-muted mb-2">{loading ? "Loading…" : "Top 10 by qty/sales"}</div>
        <Chart options={options} series={series} type="bar" height={300} />
      </Card.Body>
    </Card>
  );
};

export default TopSellingProducts;
